import { footerLinks } from '@/mocks/home';

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="inline-block text-xl font-bold text-foreground-950 mb-4 cursor-pointer"
            >
              黑料官网
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              提供51黑料官网、黑料官网入口及黑料网官网访问指引。实时同步黑料网最新地址、
              黑料网永久地址与黑料网首页链接，一站式解决用户找入口难题，直达黑料内容主页。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleClick('#contact'); }} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleClick('#contact'); }} className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-500 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">网站导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.nav.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门话题</h4>
            <ul className="space-y-2.5">
              {footerLinks.topics.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              {footerLinks.help.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/60 pt-8">
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-foreground-700 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-500">诚邀优质内容平台与媒体伙伴加入合作生态，共同为用户提供更丰富的娱乐资讯服务。</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 黑料官网 - 51黑料官网入口与黑料网官网。本站仅提供导航指引，不对链接内容负责。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-foreground-500">黑料网最新地址已更新</span>
              <span className="text-xs text-foreground-500">黑料网永久地址同步中</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}